import { Step } from "react-joyride";
import { VisibilityStates } from "../../types/VisibilityStates";

export const tourStepsNewCollection = (
  visibilityStates: VisibilityStates,
): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.new-collection-page",
      content:
        "Step 1 of creating a collection. Give it a name and category, then continue to add items.",
      disableBeacon: true,
    },
    {
      target: ".collection-name-input",
      content:
        "Choose a name students will recognize, such as Letter Fluency or Week 3 Math Facts.",
      ...(visibilityStates.isCollectionNameVisible ? { isOpen: true } : {}),
    },
    {
      target: "#categorySelect",
      content:
        "The category changes what you can generate on the next page, such as letters, numbers, math, or number sense.",
      ...(visibilityStates.isCategorySelectVisible ? { isOpen: true } : {}),
    },
    {
      target: "#stageSelect",
      content:
        "Mastery stage tags which group this deck belongs to: Beginner, Intermediate, Advanced, or None. Learners use My stage on Your Collections to only see that group. Leave None for one-off decks. You can change the tag later if the deck feels easier or harder than you thought.",
      ...(visibilityStates.isStageSelectVisible ? { isOpen: true } : {}),
    },
    {
      target: "#publicCheckbox",
      content:
        "Leave this unchecked to keep the collection private. Check it only if you want other users to find it on Discover Collections.",
      ...(visibilityStates.isPublicCheckboxVisible ? { isOpen: true } : {}),
    },
    {
      target: ".submit-collection-button",
      content:
        "Click Next to set how many items to include, generate a list, or add your own items.",
      ...(visibilityStates.isSubmitButtonVisible ? { isOpen: true } : {}),
    },
  ];

  return steps.filter((step) => {
    const target = step.target as string;
    if (target === ".collection-name-input")
      return visibilityStates.isCollectionNameVisible;
    if (target === "#categorySelect")
      return visibilityStates.isCategorySelectVisible;
    if (target === "#stageSelect")
      return visibilityStates.isStageSelectVisible;
    if (target === "#publicCheckbox")
      return visibilityStates.isPublicCheckboxVisible;
    if (target === ".submit-collection-button")
      return visibilityStates.isSubmitButtonVisible;
    return true;
  });
};
